export class Populations {
  public static Default = 'Default';
  public static NonRenewingPopulation = 'Non Renewing';
  public static Partner = 'Partners';
  public static Free = 'Free';
  public static Suite = 'Suite';
  public static Pts = 'Pts';
}
